import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext } from 'react';
import { createGlobalStyle } from 'styled-components';
import { color } from '../../../styles/styles.js';
import { FCTheme } from '../../../theming/FCTheme.js';
var GlobalStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    body {\n      margin: 0;\n      padding: 0;\n      font: 13px/1.5 'Helvetica Neue', Arial, 'Liberation Sans', FreeSans, sans-serif;\n      background-color: ", ";\n      color: ", ";\n    }\n"], ["\n    body {\n      margin: 0;\n      padding: 0;\n      font: 13px/1.5 'Helvetica Neue', Arial, 'Liberation Sans', FreeSans, sans-serif;\n      background-color: ", ";\n      color: ", ";\n    }\n"])), function (props) {
  return props.theme === 'dark' ? color.darkModeDarkest : props.backgroundColor;
}, function (props) {
  return props.theme === 'dark' ? color.medium : color.dark;
});

var FCGlobalStyles = function FCGlobalStyles(_a) {
  var backgroundColor = _a.backgroundColor;
  var theme = useContext(FCTheme);
  return /*#__PURE__*/React.createElement(GlobalStyles, {
    backgroundColor: backgroundColor,
    theme: theme.theme
  });
};

var templateObject_1;
export default FCGlobalStyles;